export default __webpack_public_path__ + "static/media/25.dd99ee32.png";